import { FC, PropsWithChildren } from 'react';
import {
  StyledSideImage,
  StyledSideImageLayoutContent,
  StyledSideImageLayoutWrapper,
} from './SideImageLayout.styles';
import { PageHeader, UserWidgetProps } from '../../organisms/PageHeader';
import {
  StyledConstrainedContent,
  StyledConstrainedLayout,
} from '../ConstrainedLayout/ConstrainedLayout.styles';
import { PageHeading } from '../../atoms/PageHeading';

export interface SideImageLayoutProps extends PropsWithChildren {
  image: string;
  userWidget: UserWidgetProps;
  heading: {
    title: string | JSX.Element;
    subtitle?: string | JSX.Element;
    loading?: boolean;
  };
}

/**
 * Similar to {@link ConstrainedLayout} but with an image that
 * appears to the side of the content in larger viewports.
 * Good for short, static content.
 */
export const SideImageLayout: FC<SideImageLayoutProps> = ({
  children,
  image,
  userWidget: { login, logout, userPhoto, userName },
  heading: { title, subtitle, loading },
}) => {
  return (
    <StyledConstrainedLayout>
      <StyledConstrainedContent>
        <PageHeader
          login={login}
          logout={logout}
          userPhoto={userPhoto}
          userName={userName}
        />
        <StyledSideImageLayoutWrapper>
          <StyledSideImageLayoutContent>
            <PageHeading
              data-testid="heading"
              title={title}
              subtitle={subtitle}
              loading={loading}
            />
            {children}
          </StyledSideImageLayoutContent>
          <StyledSideImage src={image} />
        </StyledSideImageLayoutWrapper>
      </StyledConstrainedContent>
    </StyledConstrainedLayout>
  );
};

export default SideImageLayout;
